import {publicAsset} from 'helpers/publicAsset'
import {Avatar, Button, DatePicker, Form, Input, List, Modal, Radio, Select,} from 'antd'
import {
    exam_createExamination_Api,
    exam_deleteExamination_Api,
    exam_editExamination_Api,
    exam_getExaminationById_Api,
    exam_getExamQuestionSets_Api,
    exam_resetExamination_Api,
    host_getsbyOwner_api,
} from 'apis'
import {baseFieldTypes} from 'apis/base/baseFieldTypes'
import {getId, getType} from 'apis/model/base'
import FieldsFactory, {FieldHeader} from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import UseState from 'components/UseState'
import {Formik} from 'formik'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import {dayjsFromSeconds, minutesFromDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Async from 'modules/asyncCache/components/Async'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {BsCaretDownFill, BsCheckLg,} from 'react-icons/bs'
import {IoAddOutline,} from 'react-icons/io5'
import {Link, useLocation} from 'react-router-dom'
import {compose, mapProps} from 'recompose'
import {ErrorSummaries} from 'views/AppLocals/factory/createEditableForm'
import {getResponseItem, getResponseItems, renderElse, renderSelf, shallowDiff,} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {convertFromString, convertToString} from 'views/SlateEditor/functions'
import {NullAsDefault, renderIf, renderIfElse} from '../../Shared'
import {appFieldTypes} from '../appFieldTypes'
import {modalWidth} from '../configs'
import CustomRichEditor from '../custom/CustomRichEditor'
import {useDebounceSearch} from '../custom/DebounceSearch'
import {PhotoUploadComposite} from '../custom/PhotoField'
import {SelectWidget} from '../custom/ReactSelectComponents'
import {CustomKeys} from '../CustomKeys'
import EntityList from '../EntityList'
import {showDeleteConfirmDialog} from '../factory/createConfirmDialog'
import createContextMenu from '../factory/createContextMenu'
import {notifyOnError} from '../factory/createErrorEvent'
import {createControlledFormField, createNumberControlledInput,} from '../factory/createFormField'
import {NotificationActionTypes, successNotify,} from '../factory/createNotification'
import {bindQueryParam, bindQueryParams} from '../functions/routerHelper'
import gModel from '../gModel'
import {HostPickerModal} from '../Host/components/AddHostModal'
import {renderHost} from '../Host/functions/renderHost'
import HostContext, {HostProvider} from '../Host/HostContext'
import {BiTrash} from "react-icons/bi";
import {PiEraserFill, PiGearSixFill, PiXCircle} from "react-icons/pi";
import {IoIosTimer} from "react-icons/io";
import {GoDotFill} from "react-icons/go";
import {LoginContext} from "../../../components/LoginContext";
import {isSystemAdmin} from "../../../helpers/authUtils";
import {convertToDayjs} from "../../../helpers/datetimeHelpers";
import Pure from "../../../components/Pure";
import {LocalContext} from "../../../modules/local/LocalContext";
import filterOption from "../../../helpers/filterOption";
import dayjs from "dayjs";
import {ActionModalWrapper} from "../../../components/form/ActionModalWrapper";
import {createDateComponent} from "../../../components/form/fields/DateField";
import LoadingBlock from "../../Loading/LoadingBlock";
import {Section} from "components/form/ModernForm";

const ExamContext = React.createContext({})

const renderQSItem =
    ({selected_id, onItemClick = NullAsDefault}) =>
        (item, index) =>
            (
                <div
                    key={index}
                    className="relative rounded-lg  border border-color-50 hover:shadow-items mb-3">
                    <Translate>
                        {(t) => (
                            <div
                                className="flex items-center gap-2 px-3 py-2 cursor-pointer"
                                onClick={() => {
                                    onItemClick(item)
                                }}>
                                <div className="flex flex-col flex-1 gap-1">
                                    <div className="font-bold text-color-100">{getTitle(item)}</div>
                                    <div className="flex items-center gap-1 text-xs italic leading-tight">
                  <span className="font-bold text-color-000">
                    {_.get(item, 'total_questions')}
                  </span>
                                        <span className="text-color-400">{t('ask')}</span>
                                    </div>
                                </div>
                                {renderIf(
                                    selected_id === getId(item),
                                    <BsCheckLg
                                        size={20}
                                        className="text-green-500"
                                    />
                                )}
                            </div>
                        )}
                    </Translate>
                </div>
            )

export const BooleanPicker = ({
                                  name,
                                  value,
                                  onChange,
                                  defaultValue,
                                  disabled = false,
                                  options = appFieldTypes.yesOrno,
                              }) =>
    renderElse(
        _.isEmpty(options),
        <Translate>
            {(t) => (
                <Radio.Group
                    name={name}
                    value={value}
                    disabled={disabled}
                    buttonStyle="solid"
                    className="w-full custom-radio-button"
                    defaultValue={defaultValue}
                    onChange={(event) => {
                        onChange(createValue(name, event.target.value))
                    }}>
                    {Array.from(options ?? []).map(({label, value}) => (
                        <React.Fragment key={value}>
                            <Radio.Button value={value}>{t(label)}</Radio.Button>
                        </React.Fragment>
                    ))}
                </Radio.Group>
            )}
        </Translate>
    )

const QuestionSetSelector = ({
                                 toggle,
                                 isToggle,
                                 onChange,
                                 owner_id,
                                 owner_type,
                                 defaultOption,
                             }) => {
    const [keyword, __, searchInput] = useDebounceSearch({
        timeout: 500,
        className: 'w-full rounded-md',
    })

    const handleClick = (item) => {
        onChange(getId(item), item)
        toggle(false)
    }

    const apiInfo = exam_getExamQuestionSets_Api

    const cacheId = [
        apiInfo.path.replace(':id', owner_id).replace(':type', owner_type),
        'select',
    ].join('/')

    return (
        <Translate>
            {(t) => (
                <React.Fragment>
                    <div
                        onClick={() => {
                            toggle(true)
                        }}
                        className="flex items-center background border rounded-md px-2 py-1">
            <span className="max-lines-1 flex-1">
              {getTitle(defaultOption) || t('choose question set')}
            </span>
                        <BsCaretDownFill
                            size={10}
                            className="text-color-400"
                        />
                    </div>
                    <Modal
                        footer={null}
                        closable={false}
                        open={!!isToggle}
                        destroyOnHidden={true}
                        onCancel={() => {
                            toggle(false)
                        }}>
                        <div className="flex flex-col space-y-3">
                            <div className="text-center text-xl font-bold uppercase text-color-000">
                                {t('choose question set')}
                            </div>
                            {searchInput}
                            <Async
                                key={keyword}
                                apiInfo={apiInfo}
                                query={bindQueryParams([
                                    {
                                        id: owner_id,
                                    },
                                    {
                                        type: owner_type,
                                    },
                                ])}
                                values={{
                                    keyword,
                                }}>
                                {({response, isLoading = false}) => {
                                    if (!!isLoading) {
                                        return <LoadingBlock/>
                                    }
                                    const items = getResponseItems(response)

                                    const dataSource =
                                        defaultOption?.id &&
                                        _.find(items, {
                                            id: defaultOption.id,
                                        })
                                            ? items
                                            : [defaultOption, ...items].filter((e) => !_.isEmpty(e))

                                    console.log(1111111111, items, dataSource)

                                    return (
                                        <List
                                            loading={!!isLoading}
                                            dataSource={dataSource}
                                            renderItem={renderQSItem({
                                                onItemClick: handleClick,
                                                selected_id: getId(defaultOption),
                                            })}
                                            pagination={{
                                                pageSize: 8,
                                                hideOnSinglePage: true,
                                            }}
                                        />
                                    )
                                }}
                            </Async>
                        </div>
                    </Modal>
                </React.Fragment>
            )}
        </Translate>
    )
}

const QuestionSetValueOptions = Object.freeze({
    ALL: {
        label: 'all',
        value: 'ALL',
        hasValue: false,
    },
    PER: {
        label: 'percent',
        value: 'PER',
        suffix: '%',
        hasValue: true,
    },
    VOL: {
        label: 'volume',
        value: 'VOL',
        suffix: 'sentence',
        hasValue: true,
    },
})

const QuestionRow = ({
                         index,
                         onChange,
                         onRemove,
                         owner_id,
                         owner_type,
                         error = false,
                         defaultValues = {
                             value: undefined,
                             exam_question_set_id: undefined,
                             exam_question_set: undefined,
                             value_type: QuestionSetValueOptions.ALL.value,
                         },
                         type_options = [
                             QuestionSetValueOptions.ALL,
                             QuestionSetValueOptions.PER,
                             QuestionSetValueOptions.VOL,
                         ],
                         ...props
                     }) => {
    const t = useTranslate();

    const value = _.get(props, 'value') || {}

    const handleChange = (event) => {
        onChange({
            ...value,
            [event.target.name]: event.target.value,
        })
    }

    const setValues = (values) => {
        onChange({
            ...value,
            ...values,
        })
    }

    const {exam_question_set, value_type, exam_question_set_id} = value ?? {}

    const selected_value_type = _.find(QuestionSetValueOptions, {
        value: value_type,
    })

    const addon = (
        <SelectWidget
            name="value_type"
            value={value_type}
            style={{minWidth: 80}}
            placeholder={t('value type')}
            defaultValue={defaultValues.value_type}
            onChange={(value) => {
                setValues({
                    value: undefined,
                    value_type: value,
                })
            }}>
            {Array.from(type_options).map(({label, value}) => (
                <Select.Option
                    key={value}
                    value={value}>
                    {t(label)}
                </Select.Option>
            ))}
        </SelectWidget>
    )

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center gap-3">
        <span className="flex-1 text-sm text-color-400 italic tracking-wide">
          <GoDotFill size={10} className="mr-1 text-color-400"/>
            {`${t('questions set')} ${index + 1} : `}
        </span>
                {renderIf(
                    _.isFunction(onRemove),
                    <PiXCircle
                        size={16}
                        onClick={() => {
                            showDeleteConfirmDialog({
                                translate: t,
                                icon: <PiXCircle className="anticon"/>,
                                title: 'delete question set',
                                message: 'are you sure you want to delete it question set',
                                okText: 'sure',
                                cancelText: 'ignore',
                                onOk: () => {
                                    onRemove()
                                },
                            })
                        }}
                        className="mr-2 text-red-300 hover:text-red-600 cursor-pointer"
                    />
                )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 flex-1 gap-2">
                <UseState>
                    {([isToggle, toggle]) => (
                        <QuestionSetSelector
                            onChange={(value, {owner, ...option} = {}) => {
                                setValues({
                                    exam_question_set_id: value,
                                    exam_question_set: option,
                                })
                            }}
                            defaultOption={exam_question_set}
                            {...{isToggle, toggle, owner_id, owner_type}}
                        />
                    )}
                </UseState>
                {renderIfElse(
                    !!selected_value_type?.hasValue,
                    <Input
                        className="flex-1"
                        min={0}
                        name="value"
                        type="number"
                        onChange={handleChange}
                        placeholder={t('value')}
                        value={_.get(value, 'value')}
                        addonBefore={_.isEmpty(type_options) ? undefined : addon}
                        addonAfter={selected_value_type?.suffix ?
                            <span>{t(selected_value_type.suffix)}</span> : undefined}
                    />,
                    addon
                )}
            </div>
        </div>
    )
}

const QuestionSetCreator = ({
                                name,
                                value,
                                onChange,
                                owner_id,
                                owner_type,
                            }) => {
    const t = useTranslate()

    const [form] = Form.useForm()
    const [totalQuestion, setTotalQuestion] = useState(0)

    const calculatePercentage = (total, percent) => {
        const result = (total * percent) / 100;
        return result % 1 >= 0.5 ? Math.ceil(result) : Math.floor(result);
    }

    useEffect(() => {

        let total = 0;
        value.map(e => {
            const {exam_question_set, value, value_type} = e ?? {}
            switch (value_type) {
                case "PER":
                    const _total = calculatePercentage(exam_question_set?.total_questions, Number(value))
                    total += _total
                    break;
                case "VOL":
                    total += Number(value);
                    break;
                default:
                    total += exam_question_set?.total_questions || 0;
                    break;
            }
        })
        setTotalQuestion(total)
        form.setFieldsValue({[name]: value})
    }, [value])


    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={{[name]: value}}
            onValuesChange={(changedValues, values) => {
                const value = _.get(values, name)
                onChange(createValue(name, value))
            }}>
            <Form.List name={name}>
                {(fields, {add, remove}, {}) => (
                    <div className="flex flex-col gap-3">
                        <div className="flex items-center gap-2">
                            <FieldHeader
                                className="flex-1"
                                style={{alignItems: 'center'}}
                                renderLabel={() => (
                                    <span className="uppercase text-sm font-semibold text-color-300 tracking-wide">
                              {t('questions set')}
                                        <span className="font-normal text-xs text-color-400 italic lowercase">
                                {` (${t('total')} : ${totalQuestion || 0} ${t('ask')})`}
                              </span>
                          </span>
                                )}
                            />
                            <Button
                                size="small"
                                className="flex flex-center gap-1 button-rounded-md font-medium text-xs no-border pl-3 pr-4"
                                type="primary"
                                onClick={() =>
                                    add({value_type: QuestionSetValueOptions.ALL.value})
                                }
                                icon={<IoAddOutline size={11}/>}>
                                {t('add')}
                            </Button>
                        </div>
                        {fields.length > 0 && (
                            <div className="flex flex-col gap-3">
                                {fields.map((field, index) => (
                                    <Form.Item
                                        className="mb-0"
                                        {...field}
                                        key={field.key}>
                                        <QuestionRow
                                            index={index}
                                            onRemove={
                                                fields.length > 1
                                                    ? () => remove(field.name)
                                                    : undefined
                                            }
                                            owner_id={owner_id}
                                            owner_type={owner_type}
                                        />
                                    </Form.Item>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </Form.List>
        </Form>
    )
}

export const formSchema = {
    cover_photo: {
        children: [
            {
                name: 'cover_photo',
                component: mapProps(({form, onChange}) => {
                    const values = _.get(form, 'values', {})
                    return {
                        values,
                        onChange,
                        renderAvatar: NullAsDefault,
                        title: getTitle(values),
                        fallback_cover: publicAsset('/images/default/exam-default.jpg'),
                        renderAvatarUploader: NullAsDefault,
                    }
                })(PhotoUploadComposite),
            },
        ],
    },
    title: {
        title: 'exam title',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'exam title',
                }),
            },
        ],
    },
    about: {
        title: 'about examination',
        children: [
            {
                name: 'about',
                component: ({name, value, form, onChange}) => {
                    const {resetKey} = form?.values ?? {}
                    return (
                        <CustomRichEditor
                            {...{
                                name,
                                value,
                                resetKey,
                                onChange,
                            }}
                            className="background"
                            placeholder="about examination"
                        />
                    )
                },
            },
        ],
    },
    postscript: {
        title: 'postscript',
        children: [
            {
                name: 'postscript',
                component: createControlledFormField({
                    className: 'scrollBarThin',
                    rows: 2,
                    placeholder: 'postscript',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    description: {
        title: 'short description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    className: 'scrollBarThin',
                    rows: 3,
                    placeholder: 'short description',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    create_boolean_1: {
        inline: true,
        className: 'grid grid-cols-2 md:grid-cols-3 gap-3',
        children: [
            {
                name: 'is_auto_scoring',
                label: 'is auto scoring',
                component: createControlledFormField({
                    disabled: true,
                    Component: BooleanPicker,
                }),
            },
            {
                name: 'is_fixed_questions',
                label: 'is fixed questions',
                component: createControlledFormField({
                    disabled: true,
                    Component: BooleanPicker,
                }),
            },
        ],
    },
    edit_boolean_1: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        children: [
            {
                name: 'timelimit',
                label: 'timelimit',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <DatePicker.TimePicker
                                    placeholder={t('ex: 00:30:00')}
                                    suffixIcon={<IoIosTimer className="text-color-500"/>}
                                    showNow={false}
                                    allowClear={true}
                                    showSecond={false}
                                    className="w-full"
                                    value={convertToDayjs(value)}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            // {
            //     name: 'is_auto_scoring',
            //     label: 'is auto scoring',
            //     component: createControlledFormField({
            //         disabled: true,
            //         Component: BooleanPicker,
            //     }),
            // },
            // {
            //     name: 'is_fixed_questions',
            //     label: 'is fixed questions',
            //     component: createControlledFormField({
            //         disabled: true,
            //         Component: BooleanPicker,
            //     }),
            // },
        ],
    },

    total_of_questions: {
        title: 'total questions',
        children: [
            {
                name: 'total_of_questions',
                component: createNumberControlledInput({
                    placeholder: 'total questions',
                }),
            },
        ],
    },
    create_question_set: {
        children: [
            {
                name: 'examination_question_sets',
                component: mapProps(({name, form, value, onChange}) => ({
                    name,
                    value,
                    onChange,
                    owner_id: form?.values?.owner_id,
                    owner_type: form?.values?.owner_type,
                }))(QuestionSetCreator),
            },
        ],
    },
    edit_question_set: {
        children: [
            {
                name: 'examination_question_sets',
                component: mapProps(({name, form, value, onChange}) => ({
                    name,
                    value,
                    onChange,
                    owner_id: form?.values?.owner_id,
                    owner_type: form?.values?.owner_type,
                }))(QuestionSetCreator),
            },
        ],
    },
    score_group: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        children: [
            {
                name: 'pass_score',
                label: 'pass score',
                component: createControlledFormField({
                    min: 0,
                    type: 'number',
                    placeholder: 'pass score',
                    withValues: ({max_point, pass_score}) => ({
                        max: 100,
                        value: Math.min(100, pass_score),
                        addonAfter: <span className="text-sm">{`/ 100`}</span>,
                    }),
                }),
            },
            {
                name: 'credit_score',
                label: 'credit score',
                component: createControlledFormField({
                    min: 0,
                    type: 'number',
                    placeholder: 'credit score',
                    withValues: ({max_point, credit_score}) => ({
                        min: 0,
                        max: 100,
                        value: Math.min(100, credit_score),
                        addonAfter: <span className="text-sm">{`/ 100`}</span>,
                    }),
                }),
            },
            {
                name: 'distinction_score',
                label: 'distinction score',
                component: createControlledFormField({
                    min: 0,
                    type: 'number',
                    placeholder: 'distinction score',
                    withValues: ({max_point, distinction_score}) => ({
                        max: 100,
                        value: Math.min(100, distinction_score),
                        addonAfter: <span className="text-sm">{`/ 100`}</span>,
                    }),
                }),
            },
        ],
    },
    started_finished_date: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        children: [
            {
                name: 'time_open',
                label: 'started at',
                component: createDateComponent(),
            },
            {
                name: 'time_close',
                label: 'finished at',
                component: createDateComponent(),
            },
            {
                name: 'timelimit',
                label: 'timelimit',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <DatePicker.TimePicker
                                    placeholder={t('ex: 00:30:00')}
                                    showNow={false}
                                    allowClear={true}
                                    showSecond={false}
                                    className="w-full"
                                    value={value ? dayjs(new Date(value)) : undefined}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    edit_started_finished_date: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                name: 'time_open',
                label: 'started at',
                component: createDateComponent(),
            },
            {
                name: 'time_close',
                label: 'finished at',
                component: createDateComponent(),
            },
        ],
    },
    examination_paper_condition: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', '', ''],
        children: [
            {
                name: 'max_attempts',
                label: 'max No of attempts',
                description: 'Default is 0, indicating no limit.',
                component: createNumberControlledInput({
                    placeholder: 'unlimited',
                }),
            },
            {
                name: 'total_of_questions',
                label: 'total of questions',
                description: 'total of questions description',
                component: createControlledFormField({
                    type: 'number',
                    placeholder: 'total questions',
                }),
            },
            {
                name: 'max_point',
                label: 'max point',
                description: 'The total score is based on the number of questions in the exam',
                component: createControlledFormField({
                    min: 0,
                    type: 'number',
                    placeholder:
                        'The total score is based on the number of questions in the exam',
                }),
            },
        ],
    },

    privacy__active: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                name: 'privacy',
                label: 'privacy',
                component: compose(
                    withTranslate,
                    mapProps(({translate, name, value, onChange}) => ({
                        name,
                        value,
                        onChange,
                        buttonStyle: 'solid',
                        className: 'w-full custom-radio-button',
                        defaultValue: value,
                        children: baseFieldTypes.privacy.map(({value, label}) => (
                            <Radio.Button
                                key={value}
                                value={value}>
                                {translate(label)}
                            </Radio.Button>
                        )),
                    }))
                )(Radio.Group),
            },
            {
                name: 'active',
                label: 'active',
                component: createControlledFormField({
                    Component: BooleanPicker,
                }),
            },
        ],
    },
    display_result_on_final: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                name: 'display_result_on_final',
                label: 'display result on final only',
                component: createControlledFormField({
                    Component: BooleanPicker,
                }),
            },
            {
                name: 'is_hidden_question_list',
                label: 'hide question list',
                component: createControlledFormField({
                    Component: BooleanPicker,
                }),
            },
        ],
    },

    categories: {
        title: 'categories',
        children: [
            {
                name: 'categories',
                component: ({name, value, onChange}) => (
                    <Pure input={[value]}>
                        <Translate>
                            {(t) => (
                                <LocalContext.Consumer>
                                    {({appConfig}) => {
                                        const {categories} = appConfig || {}
                                        const options = Array.from(categories || []).map(
                                            (category) => ({
                                                label: t(getTitle(category)),
                                                value: category?.id,
                                                ...category,
                                            })
                                        )
                                        return (
                                            <SelectWidget
                                                value={value}
                                                mode="multiple"
                                                className="w-full"
                                                placeholder={t('click to select')}
                                                showSearch={true}
                                                allowClear={true}
                                                options={options}
                                                filterOption={filterOption}
                                                onChange={(value, option) => {
                                                    onChange(createValue(name, value))
                                                }}
                                            />
                                        )
                                    }}
                                </LocalContext.Consumer>
                            )}
                        </Translate>
                    </Pure>
                ),
            },
        ],
    },
}

const CreateExaminationModal = ({
                                    owner_id,
                                    owner_type,
                                    initialValues,
                                    onCancel = NullAsDefault,
                                    onSubmit = NullAsDefault,
                                }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}

        const {title, timelimit, examination_question_sets} = values ?? {}

        if (!title) {
            errors.title = t('required field')
        }

        if (!timelimit) {
            errors.timelimit = t('required field')
        }

        if (
            _.isEmpty(examination_question_sets) ||
            _.find(examination_question_sets, ({exam_question_set}) =>
                _.isEmpty(exam_question_set)
            )
        ) {
            errors.examination_question_sets = {
                title: t('question set'),
                message: t('required field'),
                description: t('required field'),
            }
        }

        return errors
    }

    const _initialValues = useMemo(
        () => ({
            owner_id,
            owner_type,
            max_point: 100,
            pass_score: 50,
            credit_score: 70,
            distinction_score: 90,
            is_auto_scoring: 1,
            is_hidden_question_list: 0,
            is_fixed_orders: 1,
            is_fixed_questions: 0,
            total_of_questions: 10,
            display_result_on_final: 0,
            examination_question_sets: [
                {value_type: QuestionSetValueOptions.ALL.value},
            ],
            time_close: dayjs().endOf('day').startOf('minute'),
            ...(initialValues ?? {}),
        }),
        [initialValues, owner_id, owner_type]
    )

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {
                    resetKey,
                    timelimit,
                    examination_question_sets,
                    owner_id,
                    owner_type,
                    ...rest
                } = values ?? {}
                onSubmit({
                    ...rest,
                    timelimit: minutesFromDayjs(timelimit),
                    examination_question_sets: _.isEmpty(examination_question_sets)
                        ? undefined
                        : JSON.stringify(
                            Array.from(examination_question_sets).map((e) =>
                                _.omit(e, ['exam_question_set'])
                            )
                        ),
                })
            }}
            enableReinitialize={true}>
            <React.Fragment>
                <ActionModalWrapper action={<FormActionBar submitText="create"/>}>
                    <div className="flex flex-col gap-4">
                        <Section title={t('basic information')}>
                            <FieldsFactory formSchema={[formSchema.title]}/>
                        </Section>
                        <Section title={t('schedule')}>
                            <FieldsFactory formSchema={[formSchema.started_finished_date]}/>
                        </Section>
                        <Section title={t('exam paper settings')}>
                            <FieldsFactory formSchema={[formSchema.examination_paper_condition]}/>
                        </Section>
                        <Section>
                            <FieldsFactory formSchema={[formSchema.create_question_set]}/>
                        </Section>
                    </div>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

const EditExaminationModal = ({
                                  owner_id,
                                  owner_type,
                                  onCancel = NullAsDefault,
                                  onSubmit = NullAsDefault,
                                  initialValues = {},
                              }) => {
    const t = useTranslate()

    const [current, setCurrent] = useState('overview')

    const _initialValues = useMemo(() => {
        const {
            about,
            timelimit = 0,
            examination_question_sets = [],
            ...rest
        } = initialValues ?? {}
        const _timelimit = dayjsFromSeconds(timelimit * 60)
        return {
            ...rest,
            owner_id,
            owner_type,
            timelimit: _timelimit,
            about: convertFromString(about),
            examination_question_sets: Array.from(
                examination_question_sets ?? []
            ).map((question) => ({
                exam_question_set_id: getId(question?.exam_question_set),
                ...question,
            })),
            resetKey: undefined
        }
    }, [initialValues, owner_id, owner_type])

    const validate = (values) => {
        let errors = {}

        const {title, timelimit, examination_question_sets} = values ?? {}

        if (!title) {
            errors.title = t('required field')
        }

        if (!timelimit) {
            errors.timelimit = t('required field')
        }

        if (
            _.isEmpty(examination_question_sets) ||
            _.find(examination_question_sets, ({exam_question_set}) =>
                _.isEmpty(exam_question_set)
            )
        ) {
            errors.examination_question_sets = {
                title: t('question set'),
                message: t('required field'),
                description: t('required field'),
            }
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {
                    about,
                    resetKey,
                    timelimit,
                    examination_question_sets,
                    owner_id,
                    owner_type,
                    ...rest
                } = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            about: about ? convertToString(about) : undefined,
                            timelimit: timelimit ? minutesFromDayjs(timelimit) : undefined,
                            examination_question_sets: _.isEmpty(examination_question_sets)
                                ? undefined
                                : JSON.stringify(
                                    Array.from(examination_question_sets).map((e) =>
                                        _.pick(e, ['value', 'value_type', 'exam_question_set_id'])
                                    )
                                ),
                        },
                        _.isUndefined
                    )
                )
            }}
            // enableReinitialize={true}
        >
            <React.Fragment>
                <ErrorSummaries/>
                <ActionModalWrapper
                    tab={current}
                    action={<FormActionBar submitText="save"/>}
                    onTabChange={(key) => {
                        setCurrent(key)
                    }}
                    tabs={[
                        {
                            key: 'overview',
                            label: 'overview',
                            component: ({child}) => child,
                        },
                        {
                            key: 'about',
                            label: 'about examination',
                            component: () => (
                                <FieldsFactory formSchema={[formSchema.about]}/>
                            ),
                        },
                        {
                            key: 'questions',
                            label: 'questions set',
                            component: () => (
                                <FieldsFactory formSchema={[formSchema.edit_question_set]}/>
                            ),
                        },
                        {
                            key: 'hosts',
                            label: 'co-hosts',
                            component: () => (
                                <HostProvider
                                    container={initialValues}
                                    autoRefreshKey="refreshToken">
                                    <ExaminationHostsModal
                                        onCancel={onCancel}
                                        renderFooter={NullAsDefault}
                                        {...{owner_id, owner_type}}
                                    />
                                </HostProvider>
                            ),
                        },
                    ]}>
                    <FieldsFactory
                        formSchema={[
                            formSchema.title,
                            formSchema.description,
                            formSchema.postscript,
                            formSchema.edit_started_finished_date,
                            formSchema.examination_paper_condition,
                            formSchema.edit_boolean_1,
                            formSchema.score_group,
                        ]}
                    />
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

const ExaminationInfo = ({item, Wrapper = 'div'}) => {
    const owner = _.get(item, 'owner')

    return (
        <Wrapper className="flex items-center gap-3 p-3 background border border-color-50 rounded-lg">
            <Avatar
                size={35}
                src={_.get(owner, 'avatar')}
                className="background-200 uppercase font-medium text-lg">
                {_.first(getTitle(owner))}
            </Avatar>
            <Link
                to={getLinkToDetail(owner)}
                className="font-semibold text-primary">
                {getTitle(owner)}
            </Link>
        </Wrapper>
    )
}

const ExaminationHosts = ({owner_id, owner_type}) => {
    const apiInfo = host_getsbyOwner_api

    const location = useLocation()

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', owner_id).replace('prop', owner_type),
                `refreshToken=${_.get(location.state, 'refreshToken')}`,
            ].join('/'),
        [owner_id, owner_type, location.state]
    )

    return (
        <EntityList
            key={refreshKey}
            apiInfo={apiInfo}
            renderItem={renderHost()}
            RenderEntity={React.Fragment}
            query={bindQueryParams([{id: owner_id}, {prop: owner_type}])}
        />
    )
}

export const ExaminationHostsModal = ({
                                          owner_id,
                                          owner_type,
                                          header = null,
                                          onCancel = NullAsDefault,
                                          renderFooter = renderSelf,
                                      }) => {
    const t = useTranslate()

    const {handleAction, container} = useContext(HostContext)

    const [refreshToken, setToken] = useState()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onRequest = (item) => {
        setAction({type: CRUD.CREATE, value: item})
    }

    const modal = useMemo(() => {
        switch (action.type) {
            case CRUD.CREATE:
                return (
                    <Modal
                        footer={null}
                        onCancel={() => {
                            setAction({})
                        }}
                        open={action.type}
                        destroyOnHidden={true}
                        width={modalWidth.medium}>
                        <HostPickerModal
                            item={action.value}
                            {...{owner_id, owner_type}}
                        />
                    </Modal>
                )
            default:
                break
        }
        return null
    }, [action, owner_id, owner_type])

    return (
        <ActionModalWrapper className="flex-1 p-3">
            {header}
            <Async
                key={refreshToken}
                {...{
                    query: bindQueryParam({id: getId(container)}),
                    apiInfo: exam_getExaminationById_Api,
                }}>
                {({response, isLoading = false}) => {
                    if (!!isLoading) {
                        return <LoadingBlock/>
                    }
                    const examination = getResponseItem(response)
                    return (
                        <div className="flex flex-col space-y-3 flex-1">
              <span className="uppercase text-sm font-semibold text-color-300 tracking-wide">
                {t('host examination')}
              </span>
                            <ExaminationInfo item={examination}/>
                            <div className="flex items-center justify-between">
                <span className="text-sm text-color-300">
                  {t('list of co-host')}
                </span>
                                <Button
                                    type="primary"
                                    className="button-rounded-full no-border font-medium px-6"
                                    onClick={() => {
                                        onRequest(examination)
                                    }}>
                                    {t('add')}
                                </Button>
                            </div>
                            <ExaminationHosts
                                owner_id={getId(examination)}
                                owner_type={getType(examination)}
                            />
                            <div className="flex-1"/>
                        </div>
                    )
                }}
            </Async>
            {renderFooter(
                <div className="flex flex-col background stickyBottom">
                    <div className="flex justify-end">
                        <Button
                            ghost={true}
                            type="primary"
                            onClick={() => {
                                setAction({})
                            }}>
                            {t('close')}
                        </Button>
                    </div>
                    <div className="h-2"/>
                </div>
            )}
            {modal}
        </ActionModalWrapper>
    )
}

export const ExamProvider = ({owner_id, owner_type, children, ...props}) => {
    const t = useTranslate()

    const history = useHistory()
    const login = useContext(LoginContext)

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const [refreshKey, setRefreshKey] = useState()

    const onError = notifyOnError(t)

    const reload = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onCreate} = useAsyncAction({
        apiInfo: exam_createExamination_Api,
        query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: exam_editExamination_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onDelete} = useAsyncAction({
        apiInfo: exam_deleteExamination_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            reload()
        },
    })

    const {handleAsyncAction: onReset} = useAsyncAction({
        apiInfo: exam_resetExamination_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const confirmDelete = useCallback(
        (id) => {
            if (id) {
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete examination',
                    message: 'are you sure you want to delete it examination',
                    onOk: () => {
                        onDelete({}, {id})
                    },
                })
            }
        },
        [onDelete]
    )

    const confirmReset = useCallback(
        (id) => {
            if (id) {
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'reset examination',
                    message: 'are you sure you want to reset this examination',
                    onOk: () => {
                        onReset({}, {id})
                    },
                })
            }
        },
        [onReset]
    )

    const handleAction = (action, params) => {
        const [id, prop] = [getId(params), getType(params)]
        switch (action) {
            case 'settings':
                history.push(gModel.getLinkToSetting(params))
                break
            case CRUD.CREATE:
                setAction({type: action, value: params})
                break
            case CRUD.DELETE:
                confirmDelete(id)
                break
            case 'reset':
                confirmReset(id)
                break
            default:
                break
        }
    }

    const onCancel = () => {
        setAction({})
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <PiGearSixFill size={14} className="text-color-400"/>,
                        label: 'settings',
                        key: 'settings',
                    },
                    {
                        icon: <PiEraserFill size={14} className="text-blue-500"/>,
                        label: 'reset',
                        key: 'reset',
                        invisible: !isSystemAdmin(login)
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CRUD.DELETE,
                    },
                ].filter((e) => item && !!!e.invisible),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        const {id} = action.value || {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {title: undefined}
        let modal_params = {}
        switch (action.type) {
            case CustomKeys.add_host.name:
                return (
                    <FullSideModalLayout
                        right={true}
                        onCancel={onCancel}>
                        <HostProvider
                            container={action.value}
                            autoRefreshKey="refreshToken">
                            <div className="px-2">
                                <ExaminationHostsModal
                                    {...{onCancel, owner_id, owner_type}}
                                />
                            </div>
                        </HostProvider>
                    </FullSideModalLayout>
                )
            case CRUD.CREATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('create examination')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values)
                    },
                    owner_id, owner_type
                }
                modal_params = {
                    width: 720,
                }
                Content = CreateExaminationModal
                break
            case CRUD.UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update examination')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                    owner_id, owner_type
                }
                modal_params = {
                    width: 810,
                }
                Content = EditExaminationModal
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: exam_getExaminationById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            default:
                break
        }
        return (
            <Modal
                className="custom-modal"
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    return (
        <ExamContext.Provider
            key={JSON.stringify({owner_id, owner_type})}
            value={{
                action,
                owner_id,
                owner_type,
                refreshKey,
                onCreate,
                onUpdate,
                onDelete,
                handleAction,
                renderContextMenu,
                ...props,
            }}>
            {children}
            {modal}
        </ExamContext.Provider>
    )
}

export default ExamContext
